import React, { ReactElement } from "react";
import { ToelichtingOverlijdenHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import { PageBreak } from "../../../components/PageBreak";
import { ScenarioOverlijdenChapter } from "./scenario-overlijden-chapter";

type ToelichtingOverlijdenChapterProps = {
  hoofdstuk: ToelichtingOverlijdenHoofdstuk;
};

export const ToelichtingOverlijdenChapter = ({
  hoofdstuk,
}: ToelichtingOverlijdenChapterProps): ReactElement => {
  return (
    <>
      <PageBreak />
      <Chapter>
        <Heading level={2} text={hoofdstuk.titel} />
        <Paragraph paragraaf={hoofdstuk.paragrafen?.p3060301} />
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (<ScenarioOverlijdenChapter
          scenarioOverlijden={hoofdstuk}
          selectedAanvrager="Aanvrager1"
        />)}  
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 2) && (
          <>
            {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (
              <PageBreak />
            )}
            <ScenarioOverlijdenChapter
              scenarioOverlijden={hoofdstuk}
              selectedAanvrager="Aanvrager2"
            />
          </>
        )}  
      </Chapter>
    </>
  );
};
